module.exports = __webpack_public_path__ + "static/media/1.8d2cf1a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/slides/1.png
// module id = 638
// module chunks = 0